import { DateTime } from 'luxon';
import { pad } from './string';

export const Zones = {
  UTC: 'utc',
  JST: 'Asia/Tokyo',
};
const defaultOptions = {
  zone: Zones.UTC,
};

export const fmtAs = (date: string, fmt: string) => {
  if (!date) return null;
  const datetime = DateTime.fromISO(date, defaultOptions);
  return datetime.toFormat(fmt);
};

export const serializeDate = ({ year, month, day }, separator = '/') => {
  if (!year) return '';

  let r = year;
  if (month) r += `${separator}${pad(month, 2)}`;
  if (day) r += `${separator}${pad(day, 2)}`;

  return r;
};

export const serializeDateJp = ({ year, month, day }) => {
  if (!year) return '';

  let r = `${year}年`;
  if (month) r += `${pad(month, 2)}月`;
  if (day) r += `${pad(day, 2)}日`;

  return r;
};

export const splitDate = (date: string = '', separator = '/'): string[] => {
  if (!date) return [];
  return `${date}`.split(separator);
};
